import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Edit, CheckBox, CheckBoxOutlineBlank, Clear } from '@mui/icons-material';
import { TableCellStyledWithActions } from '../../../../components/list/TableComponentsStyled';

const AuthorizationListActionCell = ({ authorization, index, onRefineAuthorization, onUnrefineAuthorization, dispatch, userGroups }) => {
  const { t } = useTranslation();

  const onCheckAll = () => {
    dispatch({ type: 'OnSetAll', authorizationId: authorization.webAuthorizationId, value: true, userGroups });
  };
  const onUncheckAll = () => {
    dispatch({ type: 'OnSetAll', authorizationId: authorization.webAuthorizationId, value: false, userGroups });
  };

  return (
    <TableCellStyledWithActions>
      {authorization.authorizationContextType.refine ? (
        <IconButton
          color='primary'
          tooltip={t('Authorization.RefineTooltip')}
          onClick={() => onRefineAuthorization(authorization.webAuthorizationId)}
        >
          <Edit />
        </IconButton>
      ) : (
        <></>
      )}
      {authorization.authorizationContextType.refine && authorization.isRefined ? (
        <IconButton color='primary' tooltip={t('Authorization.UnrefineTooltip')} onClick={() => onUnrefineAuthorization(index)}>
          <Clear />
        </IconButton>
      ) : (
        <></>
      )}
      <IconButton disabled={authorization.isRefined} color='primary' tooltip={t('Authorization.CheckAllTooltip')} onClick={onCheckAll}>
        <CheckBox />
      </IconButton>
      <IconButton disabled={authorization.isRefined} color='primary' tooltip={t('Authorization.UncheckAllTooltip')} onClick={onUncheckAll}>
        <CheckBoxOutlineBlank />
      </IconButton>
    </TableCellStyledWithActions>
  );
};

AuthorizationListActionCell.propTypes = {
  authorization: PropTypes.object.isRequired,
  userGroups: PropTypes.array.isRequired,
  onRefineAuthorization: PropTypes.func.isRequired,
  onUnrefineAuthorization: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default AuthorizationListActionCell;
